import React from 'react';

/**
 * KPI / stat card. Gold accent on the hero number, optional signed delta and a
 * free-form sub line / sparkline slot.
 *
 * props:
 * - label     : string  — uppercase muted caption
 * - value     : node    — the hero number (already formatted by the caller)
 * - gold      : bool    — render the hero number in the gold gradient (default false)
 * - delta     : node    — optional delta text (e.g. "+1.24%")
 * - deltaType : 'pos' | 'neg' | 'muted' — color of the delta (default 'muted')
 * - sub       : node    — optional small sub line under the value
 * - icon      : node    — optional leading icon next to the label
 * - children  : node    — optional sparkline / extra slot
 */
function StatCard({ label, value, gold, delta, deltaType, sub, icon, children }) {
    const deltaCls = deltaType === 'pos' ? 'gh-pos' : deltaType === 'neg' ? 'gh-neg' : 'text-muted';
    return (
        <div className="gh-stat">
            <div className="gh-stat-label">{icon ? <span className="d-inline-flex">{icon}</span> : null}{label}</div>
            <div className={`gh-stat-value${gold ? ' gold' : ''}`}>{value}</div>
            {delta != null ? <div className={`gh-stat-delta ${deltaCls}`}>{delta}</div> : null}
            {sub != null ? <div className="gh-stat-sub">{sub}</div> : null}
            {children}
        </div>
    );
}

export default StatCard;
